import React from 'react';
interface SectionProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode;
  className?: string;
  containerSize?: 'sm' | 'md' | 'lg' | 'xl' | 'full';
  background?: 'default' | 'subtle' | 'none';
}
export function Section({
  children,
  className = '',
  containerSize = 'lg',
  background = 'none',
  ...props
}: SectionProps) {
  const maxSizes = {
    sm: 'max-w-3xl',
    md: 'max-w-5xl',
    lg: 'max-w-7xl',
    xl: 'max-w-[96rem]',
    full: 'max-w-full'
  };
  const backgrounds = {
    default: 'bg-slate-950',
    subtle: 'bg-slate-900/50',
    none: ''
  };
  return <section className={`w-full py-16 md:py-24 px-4 sm:px-6 lg:px-8 ${backgrounds[background]} ${className}`} {...props} data-id="element-12">
      <div className={`mx-auto ${maxSizes[containerSize]}`} data-id="element-13">{children}</div>
    </section>;
}